import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { type ReactNode } from 'react';

import { theme } from './theme';

/**
 * Light and dark follow the OS, through MUI's CSS variables rather than through
 * React state — see the note in `theme.ts`. There is no in-app toggle: a toggle is
 * a preference to store, sync, and reconcile with the OS, for a back-office nobody
 * customises.
 *
 * `CssBaseline` is inside the provider deliberately — it reads the theme to set the
 * page background, so outside it the body stays white under a dark theme.
 */
export function AdminThemeProvider({
  children,
}: {
  children: ReactNode;
}): ReactNode {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
